import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";

export const SET_LOADING = "saga/membershipUnits/SET_LOADING";
export const SET_PREV_PAGE_FILTERS = "saga/membershipUnits/SET_PREV_PAGE_FILTERS";
export const UPDATE_PREVIOUS_TOGGLE = "saga/membershipUnits/SET_PREVIOUS_TOGGLE";

export const FETCH_CURRENT_USER = "saga/membershipUnits/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/membershipUnits/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/membershipUnits/FETCH_CURRENT_USER_FAILURE";

export const UPDATE_ALL_DATA = "saga/membershipUnits/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/membershipUnits/UPDATE_ALL_DATA_SUCCESS";
export const UPDATE_ALL_DATA_FAILURE = "saga/membershipUnits/UPDATE_ALL_DATA_FAILURE";

export const FETCH_MEMBERSHIP_UNITS_SUCCESS = "saga/membershipUnits/FETCH_MEMBERSHIP_UNITS_SUCCESS";
export const FETCH_MEMBERSHIP_UNITS_FAILURE = "saga/membershipUnits/FETCH_MEMBERSHIP_UNITS_FAILURE";

export const FETCH_MEMBERSHIP_DETAILS_CHART_SUCCESS =
  "saga/membershipUnits/FETCH_MEMBERSHIP_DETAILS_CHART_SUCCESS";
export const FETCH_MEMBERSHIP_DETAILS_FAILURE =
  "saga/membershipUnits/FETCH_MEMBERSHIP_DETAILS_FAILURE";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA),
  updatePreviousDataToggle: createAction(UPDATE_PREVIOUS_TOGGLE)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
}

export function* getCurrentUserData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: payload.user });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date }
  });

  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  const allSagas = [
    getMembershipUnits({ short_url, organization_id, date: payload.date }),
    getMembershipDetails({ organization_id, short_url, date: payload.date })
  ];

  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date }
  });

  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  const allSagas = [
    getMembershipUnits({ short_url, organization_id, date: payload.date }),
    getMembershipDetails({ organization_id, short_url, date: payload.date })
  ];

  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getMembershipUnits(params) {
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/membership_units/units",
      { params }
    );

    yield put({ type: FETCH_MEMBERSHIP_UNITS_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIP_UNITS_FAILURE, error });
  }
}

function* getMembershipDetails(params) {
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/membership_units/details",
      { params }
    );

    yield put({ type: FETCH_MEMBERSHIP_DETAILS_CHART_SUCCESS, payload: res.data.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIP_DETAILS_FAILURE, error });
  }
}